<tile
  (onClick)="onClick.emit()"
  [active]="active"
  [title]="data?.name"
  [description]="data?.description"
  [media]="data?.image"
  [hoverActive]="hoverActive"
>
  <ng-content></ng-content>
</tile>
